import { APIClient } from "../helpers/api_helper";
import * as url from "../helpers/url_helper";

const api = new APIClient();

export const getMealCategoryListService = (params = {}) => {
  return api.get(url.GET_MEAL_CATEGORY_LIST, params);
};

export const addMealCategoryService = (formData, queryParams) => {
  return api.create(url.POST_MEAL_CATEGORY, formData, false, queryParams);
};

export const deleteMealCategoryService = (id) => {
  return api.delete(url.DELETE_MEAL_CATEGORY(id));
};

export const editMealCategoryService = (formData, queryParams) => {
  return api.create(url.POST_MEAL_CATEGORY, formData, false, queryParams);
};

export const getCategoryByIdService=(id)=>{
  return api.get(url.GET_MEAL_CATEGORY(id));
}
